import { useEffect, useState } from "react";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

const SELF = "__self__";

// `performers` (pilot tasks only): the team people who may be credited with the work (« Réalisée par »). Left on « Moi », nothing extra is sent
// and `completed_by` alone records who closed the task.
export default function CompleteTaskDialog({ task, user, onClose, onConfirm, performers = [] }) {
  const [comment, setComment] = useState("");
  const [performer, setPerformer] = useState(SELF);
  const [saving, setSaving] = useState(false);
  useEffect(() => { setComment(""); setPerformer(SELF); }, [task]);
  const others = performers.filter((p) => !(p.kind === "user" && p.id === user?.id));
  const confirm = async () => {
    setSaving(true);
    const chosen = others.find((p) => p.key === performer);
    try { await onConfirm(task, comment.trim(), chosen ? { kind: chosen.kind, id: chosen.id } : null); } finally { setSaving(false); }
  };
  return (
    <Dialog open={!!task} onOpenChange={(open) => !open && !saving && onClose()}>
      <DialogContent>
        <DialogHeader><DialogTitle>Terminer « {task?.title} »</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-600">Clôturée par {user?.name || user?.email}. La date et l’heure seront enregistrées à la validation.</p>
        {others.length > 0 && (
          <div className="space-y-2">
            <label htmlFor="task-completion-performer" className="text-sm font-medium">Réalisée par</label>
            <Select value={performer} onValueChange={setPerformer}>
              <SelectTrigger id="task-completion-performer" data-testid="select-completion-performer"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value={SELF}>Moi ({user?.name || user?.email})</SelectItem>
                {others.map((p) => <SelectItem key={p.key} value={p.key}>{p.name}{p.detail ? ` · ${p.detail}` : ""}</SelectItem>)}
              </SelectContent>
            </Select>
            <p className="text-xs text-slate-500">Si un autre membre de l'équipe du pilote a fait le travail. Vous restez indiqué comme ayant clôturé la tâche.</p>
          </div>
        )}
        <div className="space-y-2">
          <label htmlFor="task-completion-comment" className="text-sm font-medium">Commentaire (facultatif)</label>
          <Textarea id="task-completion-comment" value={comment} onChange={(e) => setComment(e.target.value)} placeholder="Précisions sur la clôture…" />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={saving}>Annuler</Button>
          <Button onClick={confirm} disabled={saving} data-testid="confirm-complete-task">Terminer la tâche</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
